<script>
import GrsDevices from "./grsDevices";
import { getContext, onMount, onDestroy } from "svelte";
import GRSInfo from "./GRSInfo.svelte";
import SRSMonitor from "../components/SRSMonitor.svelte";
import { pref as srsMonitorPref } from '../components/SRSMonitorOptions.svelte'

const flightContext = getContext('flight')
let flight
let replayInfo

let grsDevices
let grsDevicesStore
$: selectedGRSes = Object.values($grsDevicesStore ?? {}).filter(g => g.selected)

onMount(() => {
  flight = flightContext.get()
  replayInfo = flight.replayInfoStore
  grsDevices = flight.getHandler(GrsDevices)
  grsDevicesStore = grsDevices.store
})
onDestroy(() => {
  flight.releaseHandler(GrsDevices)
})

</script>

{#if selectedGRSes?.length > 0 || $srsMonitorPref.showSRSMonitor}
  <div class='grsSidebar' >
    {#each selectedGRSes as grs}
      {#if grs.selected}
        <GRSInfo {grs} replaying={!$replayInfo.isFollowingHead} />  
      {/if}
    {/each}

    <SRSMonitor isSolo={false} /> 
  </div>
{/if}

<style>
  .grsSidebar {
    position: absolute;
    margin-top:58px;
    margin-right:16px;
    right: 0;
    width: 275px;
    color: white;
    background-color: rgb(37, 37, 37);
    padding: 0;
    border:1px solid black;
  }
</style>